import React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';

import BackgroundColor from 'common/components/core/colors/background.scss';
import MlFontIcon from 'common/components/core/font_icon/MlFontIcon';
import Tooltip from 'common/components/core/tooltip';

import theme from './IconWithHighlight.scss';

class IconWithHighlight extends React.Component {
    static defaultProps = {
        markerIcon: null,
        highlightColor: null
    };
    render() {
        const {
            highlightColor,
            markerIcon,
            theme,
            children,
            className,
            style,
            onClick,
            onMouseEnter,
            onMouseLeave,
            onMouseOver,
            onMouseOut,
            onMouseDown,
            onMouseUp,
            onContextMenu,
            testId
        } = this.props;
        const divProps = {
            onClick,
            onMouseEnter,
            onMouseLeave,
            onMouseOver,
            onMouseOut,
            onMouseDown,
            onMouseUp,
            onContextMenu,
            testId
        };
        return (
            <div
                {...divProps}
                className={classnames(className, theme.iconWrap)}
                style={style}
            >
                {markerIcon !== null ? (
                    <span className={theme.fontIconWrap}>
                        <MlFontIcon
                            className={theme.markerIcon}
                            theme={theme}
                            iconClass={isNaN(markerIcon) ? markerIcon : null}
                            numberLabel={isNaN(markerIcon) ? null : markerIcon}
                        />
                    </span>
                ) : null}
                {children}
                {highlightColor ? (
                    <span
                        className={classnames(
                            theme.highlightIcon,
                            BackgroundColor[highlightColor]
                        )}
                    />
                ) : null}
            </div>
        );
    }
}

const ThemedIconWithHighlight = themr(
    'IconWithHighlight',
    theme
)(IconWithHighlight);
const TooltipIconWithHighlight = Tooltip(ThemedIconWithHighlight);
const UnthemedTooltipIconWithHighlight = Tooltip(IconWithHighlight);

export {
    IconWithHighlight as UnthemedIconWithHighlight,
    TooltipIconWithHighlight,
    UnthemedTooltipIconWithHighlight
};
export default ThemedIconWithHighlight;
